import styled from 'styled-components';

export const Info = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;

  .infoContainer {
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 800px;

    @media screen and (max-width: 768px) {
      flex-wrap: wrap;

      .formMobile {
        order: 2;
        margin-top: 20px;
      }
    }
  }
`;

export const LabelFormInfo = styled.div`
  font-family: 'Roboto';
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  color: #71717a;
`;

export const StatusIcons = styled.div`
  font-family: 'Roboto';
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  color: #71717a;
  > div {
    width: 170px;
    padding-top: 7px;
  }
  div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 13px;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.85);
  }

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const Icons = styled.div`
  font-family: 'Roboto';
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  color: #71717a;

  @media screen and (max-width: 768px) {
    order: 1;

    .removeMobile {
      display: none;
    }
  }
  > div {
    width: 130px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 7px;
  }
  div {
    align-items: center;
    font-size: 13px;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.85);
  }
`;

export const Agendado = styled.div`
  width: 16px;
  height: 16px;
  background: #f5decc;
  border: 0.5px solid #b45309;
  box-sizing: border-box;
  border-radius: 2px;
  margin-right: 4px;
`;

export const Finalizado = styled.div`
  width: 16px;
  height: 16px;
  background: #d7f3ff;
  border: 0.5px solid #1890ff;
  box-sizing: border-box;
  border-radius: 2px;
  margin-right: 4px;
`;

export const Dados = styled.div`
  > div {
    display: flex;
    flex-wrap: wrap;
  }
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .relatorio {
    align-self: flex-end;
  }

  /* justify-content: space-between; */
  width: 100%;
  @media screen and (max-width: 768px) {
    display: none;
  }

  .caixa {
    min-width: 144px;
    height: 62px;
    border: 0.5px solid #e0e0e0;
    box-sizing: border-box;
    padding: 8px 8px 8px 16px;
  }

  .numero {
    font-family: 'Roboto';
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    color: #000000;
  }

  .texto {
    font-family: 'Roboto';
    font-weight: 500;
    font-size: 12px;
    line-height: 20px;
    color: #71717a;
  }
`;

export const ShowDate = styled.div`
  padding: 1.2rem;
  margin: 0 auto;
  font-size: 22px;
  font-weight: 500;
`;
